export const GETSTREAM_KEY = 'm75vegdfagzy'
export const BASE_URL = 'https://api.plthub.app:5000'
export const MY_MACROS_API_KEY = 'yooqLbJ7jKdGYcMLZ3c900UnigxNVyYo'
